import script from "./pp-draw-numbers-rychla-6.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-draw-numbers-rychla-6.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__